var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Img/default-avatar",
    clipPath: "url(#clip0_1912_314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#313E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.125C17.3427 17.125 18.6303 16.5916 19.5797 15.6422C20.5291 14.6928 21.0625 13.4052 21.0625 12.0625C21.0625 10.7198 20.5291 9.43217 19.5797 8.48277C18.6303 7.53337 17.3427 7 16 7C14.6573 7 13.3697 7.53337 12.4203 8.48277C11.4709 9.43217 10.9375 10.7198 10.9375 12.0625C10.9375 13.4052 11.4709 14.6928 12.4203 15.6422C13.3697 16.5916 14.6573 17.125 16 17.125ZM12.6707 18.25C9.53828 18.25 7 20.7883 7 23.9207C7 24.5184 7.48516 25 8.0793 25H23.9207C24.5184 25 25 24.5148 25 23.9207C25 20.7883 22.4617 18.25 19.3293 18.25H12.6707Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.d248caebe51ad84081012115abc03bd0.svg";
export { ForwardRef as ReactComponent };